import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b60b01d89727491653de830d3c049bac.jpg"
          alt="Transportation Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center pb-32 md:pb-0">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <img
            src="https://static.readdy.ai/image/f431233285e388c2fc3ba3a0e7c8e013/a15b2ced2c82db0b0beac99d609cfc14.jpeg"
            alt="SunRoute Group LLC"
            className="w-64 md:w-96 h-auto drop-shadow-2xl"
          />
        </div>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl text-white font-medium mb-10 drop-shadow-lg">
          {t('hero.subtitle')}
        </p>

        {/* CTA Button */}
        <a
          href="#services"
          className="inline-block bg-[#F97316] hover:bg-[#EA580C] text-white font-semibold px-10 py-4 rounded-lg transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
        >
          {t('hero.cta')}
        </a>
      </div>

      {/* SMS & WhatsApp Buttons - Only visible in hero */}
      <div className="absolute bottom-8 right-4 md:bottom-12 md:right-8 z-20 flex flex-col gap-3 md:gap-6">
        {/* Calls Button with Label */}
        <div className="flex flex-col items-center gap-1">
          <a
            href="tel:+17272036714"
            className="w-[50px] h-[50px] md:w-[70px] md:h-[70px] bg-[#34C759] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 hover:shadow-[0_8px_30px_rgba(52,199,89,0.5)] transition-all duration-300 cursor-pointer"
            aria-label="Call Us"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 md:w-[32px] md:h-[32px]" viewBox="0 0 24 24" fill="white">
              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
            </svg>
          </a>
          <span className="text-white text-[9px] md:text-xs font-medium drop-shadow-lg whitespace-nowrap">{t('hero.calls')}</span>
        </div>

        {/* SMS Button with Label */}
        <div className="flex flex-col items-center gap-1">
          <a
            href="sms:17272036714"
            className="w-[50px] h-[50px] md:w-[70px] md:h-[70px] bg-[#34C759] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 hover:shadow-[0_8px_30px_rgba(52,199,89,0.5)] transition-all duration-300 cursor-pointer"
            aria-label="Send SMS"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 md:w-[32px] md:h-[32px]" viewBox="0 0 24 24" fill="white">
              <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zM7 9h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"/>
            </svg>
          </a>
          <span className="text-white text-[9px] md:text-xs font-medium drop-shadow-lg whitespace-nowrap">{t('hero.message')}</span>
        </div>

        {/* WhatsApp Button with Label */}
        <div className="flex flex-col items-center gap-1">
          <a
            href="https://wa.me/17272036714"
            target="_blank"
            rel="noopener noreferrer"
            className="w-[50px] h-[50px] md:w-[70px] md:h-[70px] bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 hover:shadow-[0_8px_30px_rgba(37,211,102,0.5)] transition-all duration-300 cursor-pointer"
            aria-label="WhatsApp"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 md:w-[36px] md:h-[36px]" viewBox="0 0 24 24" fill="white">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
          </a>
          <span className="text-white text-[9px] md:text-xs font-medium drop-shadow-lg whitespace-nowrap">{t('hero.whatsapp')}</span>
        </div>
      </div>
    </section>
  );
}
